import React, { Component } from "react";

class GenericMerge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPrimaryId: "",
      showConfirmation: false,
    };
  }

  handleModal() {
    this.props.parentCallback(this.props.show, "cancel");
  }

  handlePrimarySelection(primaryId) {
    this.setState({
      selectedPrimaryId: primaryId,
      showConfirmation: true,
    });
  }

  handleConfirmMerge() {
    if (this.state.selectedPrimaryId) {
      this.props.parentCallback(
        this.props.show,
        "edit",
        this.state.selectedPrimaryId,
        this.props?.merged_client
      );
    }
  }

  handleBackToSelection() {
    this.setState({
      selectedPrimaryId: "",
      showConfirmation: false,
    });
  }

  getPrimaryAccount() {
    return this.props?.merged_client?.find(
      (client) => client.id == this.state.selectedPrimaryId
    );
  }

  getAccountsToMerge() {
    return this.props?.merged_client?.filter(
      (client) => client.id != this.state.selectedPrimaryId
    );
  }

  render() {
    const { merged_client = [], show, title } = this.props;
    const { selectedPrimaryId, showConfirmation } = this.state;

    if (!show) return null;

    const modalStyles = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      },
      modal: {
        backgroundColor: "white",
        borderRadius: "8px",
        maxWidth: "900px",
        width: "90%",
        maxHeight: "90vh",
        overflow: "auto",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      },
      header: {
        padding: "20px",
        borderBottom: "1px solid #dee2e6",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#011b69",
        color: "white",
      },
      body: {
        padding: "20px",
      },
      footer: {
        padding: "20px",
        borderTop: "1px solid #dee2e6",
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        backgroundColor: "#f8f9fa",
      },
      closeButton: {
        background: "none",
        border: "none",
        fontSize: "24px",
        cursor: "pointer",
        padding: "0",
        color: "white",
      },
      alertInfo: {
        padding: "12px",
        backgroundColor: "#d1ecf1",
        border: "1px solid #bee5eb",
        borderRadius: "4px",
        color: "#0c5460",
        marginBottom: "20px",
      },
      alertWarning: {
        padding: "12px",
        backgroundColor: "#fff3cd",
        border: "1px solid #ffeaa7",
        borderRadius: "4px",
        color: "#856404",
        marginBottom: "20px",
      },
      alertDanger: {
        padding: "12px",
        backgroundColor: "#f8d7da",
        border: "1px solid #f5c6cb",
        borderRadius: "4px",
        color: "#721c24",
        marginTop: "20px",
      },
      clientCard: {
        border: "2px solid #dee2e6",
        borderRadius: "8px",
        padding: "15px",
        marginBottom: "15px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        hover: "red",
      },
      clientCardSelected: {
        borderColor: "#007bff",
        backgroundColor: "#f8f9fa",
      },
      cardSuccess: {
        border: "2px solid #28a745",
        borderRadius: "8px",
        overflow: "hidden",
      },
      cardDanger: {
        border: "2px solid #dc3545",
        borderRadius: "8px",
        overflow: "hidden",
      },
      cardHeader: {
        padding: "12px 15px",
        fontWeight: "bold",
        margin: 0,
      },
      cardHeaderSuccess: {
        backgroundColor: "#28a745",
        color: "white",
      },
      cardHeaderDanger: {
        backgroundColor: "#dc3545",
        color: "white",
      },
      cardBody: {
        padding: "15px",
      },
      button: {
        padding: "8px 16px",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontWeight: "500",
      },
      buttonPrimary: {
        backgroundColor: "#007bff",
        color: "white",
      },
      buttonSecondary: {
        backgroundColor: "#6c757d",
        color: "white",
      },
      buttonDanger: {
        backgroundColor: "#dc3545",
        color: "white",
      },
      buttonDisabled: {
        backgroundColor: "#6c757d",
        opacity: 0.6,
        cursor: "not-allowed",
      },
      row: {
        display: "flex",
        flexWrap: "wrap",
        margin: "0 -15px",
      },
      colMd6: {
        flex: "0 0 50%",
        maxWidth: "50%",
        padding: "0 15px",
      },
      col12: {
        flex: "0 0 100%",
        maxWidth: "100%",
      },
    };

    return (
      <div style={modalStyles.overlay} onClick={() => this.handleModal()}>
        <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
          <div style={modalStyles.header}>
            <h5 style={{ margin: 0 }}>{title || "Merge Client Accounts"}</h5>
            <button
              style={modalStyles.closeButton}
              onClick={() => this.handleModal()}
            >
              ×
            </button>
          </div>

          <div style={modalStyles.body}>
            {!showConfirmation ? (
              // Step 1: Select Primary Account
              <div>
                <div style={modalStyles.alertInfo}>
                  <strong>Step 1:</strong> Select which account should be the
                  primary account (all other accounts will be merged into this
                  one)
                </div>

                <h6 style={{ marginBottom: "15px" }}>
                  Select Primary Account:
                </h6>
                <div>
                  {merged_client?.map((client) => (
                    <div key={client.id} style={modalStyles.col12}>
                      <div
                        style={{
                          ...modalStyles.clientCard,
                          ...(selectedPrimaryId == client.id
                            ? modalStyles.clientCardSelected
                            : {}),
                        }}
                        onClick={() => this.handlePrimarySelection(client.id)}
                        onMouseEnter={(e) => {
                          if (selectedPrimaryId !== client.id) {
                            e.currentTarget.style.borderColor = "#007bff";
                            e.currentTarget.style.backgroundColor = "#f1f8ff";
                            e.currentTarget.style.boxShadow =
                              "0 4px 8px rgba(0,123,255,0.15)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedPrimaryId !== client.id) {
                            e.currentTarget.style.borderColor = "#dee2e6";
                            e.currentTarget.style.backgroundColor = "white";
                            e.currentTarget.style.boxShadow = "none";
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <h6 style={{ marginBottom: "5px" }}>
                              {client?.name}
                            </h6>
                            <small style={{ color: "#6c757d" }}>
                              Email: {client?.email} | Mobile: {client?.mobile}
                            </small>
                            <br />
                            <small style={{ color: "#6c757d" }}>
                              City: {client?.city} | ID: {client?.id}
                            </small>
                            <br />

                            <small
                              style={{ color: "#6c757d", fontSize: "12px" }}
                            >
                              Created:{" "}
                              {new Date(client?.created_at).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </small>
                          </div>
                          <div>
                            <input
                              type="radio"
                              name="primaryAccount"
                              checked={selectedPrimaryId == client.id}
                              onChange={() =>
                                this.handlePrimarySelection(client.id)
                              }
                              style={{ transform: "scale(1.2)" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              // Step 2: Confirmation
              <div>
                <div style={modalStyles.alertWarning}>
                  <strong>Step 2:</strong> Confirm the merge operation. This
                  action cannot be undone.
                </div>

                <div style={modalStyles.row}>
                  <div style={modalStyles.colMd6}>
                    <div style={modalStyles.cardSuccess}>
                      <div
                        style={{
                          ...modalStyles.cardHeader,
                          ...modalStyles.cardHeaderSuccess,
                        }}
                      >
                        ✓ Primary Account (Will Keep)
                      </div>
                      <div style={modalStyles.cardBody}>
                        {(() => {
                          const primary = this.getPrimaryAccount();
                          return (
                            <div>
                              <h6>{primary?.name}</h6>
                              <small style={{ color: "#6c757d" }}>
                                Email: {primary?.email}
                                <br />
                                Mobile: {primary?.mobile}
                                <br />
                                City: {primary?.city}
                                <br />
                                ID: {primary?.id}
                                <br />
                                Created at:
                                {new Date(
                                  primary?.created_at
                                ).toLocaleDateString("en-US", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })}
                              </small>
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                  </div>

                  <div style={modalStyles.colMd6}>
                    <div style={modalStyles.cardDanger}>
                      <div
                        style={{
                          ...modalStyles.cardHeader,
                          ...modalStyles.cardHeaderDanger,
                        }}
                      >
                        ⚠ Accounts to Merge (Will be Merged Into Primary)
                      </div>
                      <div style={modalStyles.cardBody}>
                        {this.getAccountsToMerge().map((client) => (
                          <div
                            key={client?.id}
                            style={{
                              marginBottom: "10px",
                              paddingBottom: "10px",
                              borderBottom: "1px solid #dee2e6",
                            }}
                          >
                            <h6 style={{ marginBottom: "5px" }}>
                              {client?.name}
                            </h6>
                            <small style={{ color: "#6c757d" }}>
                              Email: {client?.email}
                              <br />
                              Mobile: {client?.mobile}
                              <br />
                              ID: {client?.id}
                              <br />
                              Created at:
                              {new Date(client?.created_at).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </small>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div style={modalStyles.alertDanger}>
                  <strong>Important:</strong> After merging:
                  <ul
                    style={{
                      marginBottom: 0,
                      marginTop: "10px",
                      paddingLeft: "20px",
                      listStylePosition: "inside",
                    }}
                  >
                    <li>
                      All data from the accounts on the right will be
                      transferred to the primary account
                    </li>
                    <li>
                      The accounts on the right will be permanently deleted
                    </li>
                    <li>This action cannot be undone</li>
                  </ul>
                </div>
              </div>
            )}
          </div>

          <div style={modalStyles.footer}>
            {!showConfirmation ? (
              <>
                <button
                  style={{
                    ...modalStyles.button,
                    ...modalStyles.buttonSecondary,
                  }}
                  onClick={() => this.handleModal()}
                >
                  Cancel
                </button>
                <button
                  style={{
                    ...modalStyles.button,
                    ...(selectedPrimaryId
                      ? modalStyles.buttonPrimary
                      : modalStyles.buttonDisabled),
                  }}
                  onClick={() => this.handlePrimarySelection(selectedPrimaryId)}
                  disabled={!selectedPrimaryId}
                >
                  Next: Review Merge
                </button>
              </>
            ) : (
              <>
                <button
                  style={{
                    ...modalStyles.button,
                    ...modalStyles.buttonSecondary,
                  }}
                  onClick={() => this.handleBackToSelection()}
                >
                  Back to Selection
                </button>
                <button
                  style={{ ...modalStyles.button, ...modalStyles.buttonDanger }}
                  onClick={() => this.handleConfirmMerge()}
                >
                  Confirm Merge
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GenericMerge;
